// variants.js
// Shared animation building blocks for the site's Motion-based reveals.

export const EASE = [0.22, 1, 0.36, 1];

export const fadeUpVariants = (distance = 24, duration = 0.6, delay = 0) => ({
    hidden: { opacity: 0, y: distance },
    show: { opacity: 1, y: 0, transition: { duration, delay, ease: EASE } },
});

export const staggerVariants = (staggerChildren = 0.15, delayChildren = 0) => ({
    hidden: {},
    show: { transition: { staggerChildren, delayChildren } },
});
